import { ApiResponse } from 'app/types-shared';
import { RemoteAdminData } from 'app/infrastructure/remote-data/remote-data';
import { CodetableWireFormat } from 'app/infrastructure/ui/form/types-codetable';
import { endpoints } from './endpoints';
import { CodeListWire, LoadCodeItemsParams } from './types';
import { CodesAccessWire } from 'app/area/codetable/types-store';

export const api = {

  loadCodeItems: async (loadParams: LoadCodeItemsParams): Promise<CodeListWire> => {

    const { id, parentId, siblingId, categoryId, query, displayNotSelected, startIndex, maxResults,
      limitFieldsTo, includeInactiveCodes, ignoreCategoryFilters, includeNotSelected, model } = loadParams;

    const response = await new RemoteAdminData(endpoints.optionsCollection(id)).resource<Response>()
      .filter({
        'api-version': '3.0',
        ...(startIndex !== undefined && { startIndex }),
        ...(maxResults !== undefined && { maxResults }),
        ...(parentId !== undefined && { parentId }),
        ...(siblingId !== undefined && { siblingId }),
        ...(displayNotSelected !== undefined && { displayNotSelected }),
        ...(includeNotSelected !== undefined && { includeNotSelected })
      })
      .create({
        ...(includeInactiveCodes && !model && { includeInactiveCodes }),
        ...(limitFieldsTo && { limitFieldsTo }),
        ...(ignoreCategoryFilters && { ignoreCategoryFilters }),
        ...(!!query && {
          query: {
            text: query
          }
        }),
        ...(categoryId !== undefined && {
          category: {
            selectedIds: [
              {
                v: categoryId
              }
            ]
          }
        }),
        ...model
      });

    const json = await response.json();

    return json.data;
  },

  loadPath: async (codetableId: number, codeId: number): Promise<CodetableWireFormat> => {

    const response = await new RemoteAdminData(endpoints.optionPath(codetableId, codeId))
      .resource<ApiResponse<CodetableWireFormat>>()
      .single();

    return response.data;
  },

  deleteCodeItem: async (codetableId: number, codeId: number, reassignReferencesToCode?: number): Promise<any> => {
    return await new RemoteAdminData(endpoints.deleteCodeItem(codetableId, codeId))
      .resource<ApiResponse<any>>()
      .filter({ reassignReferencesToCode })
      .httpDelete({});
  },

  loadCodesAccess: async (codetableId: number, codeId: number): Promise<CodesAccessWire> => {
    const request = await new RemoteAdminData(endpoints.codesAccess(codetableId))
      .resource<ApiResponse<CodesAccessWire>>()
      .filter({ id: codeId })
      .single();
    return request.data;
  }
};
